module.exports = __webpack_public_path__ + "static/media/5.8729e997.jpg";